/**
 * 가입창 UI 응답(FooterContent, UIData)은 base64로 내려오는 것이 규칙이나,
 * 인코딩되지 않은 원문이 내려오는 경우 atob이 예외를 던져 화면 전체가 깨진다.
 */

function decodeBase64Utf8(value: string): string {
  return decodeURIComponent(escape(window.atob(value)))
}

/** base64면 디코딩, 아니면 원문을 그대로 반환 */
export function decodeBase64Html(value?: string): string {
  if (!value || value === '{}') return ''

  try {
    return decodeBase64Utf8(value)
  } catch {
    return value
  }
}

/** base64 JSON → 객체. 원문 JSON, fallback 순으로 폴백 */
export function parseBase64Json<T>(value: string, fallback: T): T {
  try {
    return JSON.parse(decodeBase64Utf8(value))
  } catch {
    try {
      return JSON.parse(value)
    } catch {
      return fallback
    }
  }
}

// 기본값(dynamicUiDefaultData.UIData)이 문자열이라 UIDataType으로 좁히면 호출부 타입이 깨진다.
export function parseUiData(value: string) {
  return parseBase64Json<any>(value, {})
}
